import { createStore, setStateHelper } from "@neonumy/ant-design";
import { StoreApi, UseBoundStore } from "zustand";

const invoiceInitialState = {
  selectedInvoice: undefined,
  invoice: undefined,
  invoiceLoading: false,
  invoiceRefetch: false,
  invoiceHasLines: false,
  isDirty: false,
  showSettingsCard: false,
  showCompanyCard: false,
  showBillingCard: false,
  showDeliveryCard: false,
  showDocumentViewerDrawer: false,
};

const extrasInitialState = {
  previewUrl: "",
  lineType: "",
};

interface InvoiceStore {
  resetStore: () => void;
  selectedInvoice: InvoiceType | undefined;
  invoice: InvoiceType | undefined;
  invoiceLoading: boolean;
  invoiceRefetch: boolean;
  invoiceHasLines: boolean;
  isDirty: boolean;
  showSettingsCard: boolean;
  showCompanyCard: boolean;
  showBillingCard: boolean;
  showDeliveryCard: boolean;
  previewUrl: string;
  lineType: string;
  showDocumentViewerDrawer: boolean;
  setSelectedInvoice: (selectedInvoice: InvoiceType | undefined) => void;
  setInvoice: (invoice: InvoiceType | undefined) => void;
  setInvoiceLoading: (invoiceLoading: boolean) => void;
  setInvoiceRefetch: (invoiceRefetch: boolean) => void;
  setShowSettingsCard: (showSettingsCard: boolean) => void;
  setShowCompanyCard: (showInvoiceCard: boolean) => void;
  setInvoiceHasLines: (invoiceHasLines: boolean) => void;
  setIsDirty: (isDirty: boolean) => void;
  setPreviewUrl: (setPreviewUrl: string) => void;
  setLineType: (lineType: string) => void;
  setShowBillingCard: (showBillingCard: boolean) => void;
  setShowDeliveryCard: (showDeliveryCard: boolean) => void;
  setShowDocumentViewerDrawer: (showDocumentViewerDrawer: boolean) => void;
}

const invoiceStore: UseBoundStore<StoreApi<InvoiceStore>> = createStore<InvoiceStore>(
  (set: (fn: (draft: InvoiceStore) => void) => void) => ({
    ...invoiceInitialState,
    ...extrasInitialState,
    resetStore: () => {
      set(() => ({
        ...invoiceInitialState,
      }));
    },
    resetStoreExtras: () => {
      set(() => ({
        ...extrasInitialState,
      }));
    },
    setSelectedInvoice: (selectedInvoice: InvoiceType | undefined) => {
      setStateHelper("selectedInvoice", selectedInvoice, set);
    },
    setInvoice: (invoice: InvoiceType | undefined) => {
      setStateHelper("invoice", invoice, set);
    },
    setInvoiceLoading: (invoiceLoading: boolean) => {
      setStateHelper("invoiceLoading", invoiceLoading, set);
    },
    setInvoiceRefetch: (invoiceRefetch: boolean) => {
      setStateHelper("invoiceRefetch", invoiceRefetch, set);
    },
    setInvoiceHasLines: (invoiceHasLines: boolean) => {
      setStateHelper("invoiceHasLines", invoiceHasLines, set);
    },
    setIsDirty: (isDirty: boolean) => {
      setStateHelper("isDirty", isDirty, set);
    },
    setShowDocumentViewerDrawer: (showDocumentViewerDrawer: boolean) => {
      setStateHelper("showDocumentViewerDrawer", showDocumentViewerDrawer, set);
    },
    setPreviewUrl: (previewUrl: string) => {
      setStateHelper("previewUrl", previewUrl, set);
    },
    setLineType: (lineType: string) => {
      setStateHelper("lineType", lineType, set);
    },
    setShowSettingsCard: (showSettingsCard: boolean) => {
      setStateHelper("showSettingsCard", showSettingsCard, set);
    },
    setShowCompanyCard: (showCompanyCard: boolean) => {
      setStateHelper("showCompanyCard", showCompanyCard, set);
    },
    setShowBillingCard: (showBillingCard: boolean) => {
      setStateHelper("showBillingCard", showBillingCard, set);
    },
    setShowDeliveryCard: (showDeliveryCard: boolean) => {
      setStateHelper("showDeliveryCard", showDeliveryCard, set);
    },
  }),
);

export default invoiceStore;
